<template>
  <div class="layout-content">
    <Tabs :animated="false" v-model="showTabs" name="tabs-live-sub">
      <TabPane label="直播暂存" name="1" tab="tabs-live-sub">
        <liveStaging v-if="showTabs === '1'"></liveStaging>
      </TabPane>
      <TabPane label="回放列表" name="2" tab="tabs-live-sub">
        <liveView v-if="showTabs === '2'"></liveView>
      </TabPane>
      <TabPane label="点播列表" name="3" tab="tabs-live-sub">
        <livePlay v-if="showTabs === '3'"></livePlay>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import liveStaging from "./components/live-staging.vue";
import livePlay from "./components/live-play.vue";
import liveView from "./components/live-view.vue"; 
export default {
  name: "host-activity-live-library",
  components: {
    liveStaging,
    livePlay,
    liveView,
  },
  data () {
    return {
      showTabs: "1",
    };
  }, 
};
</script>

<style scoped lang="scss">
.layout-content { 
  background-color: #fff;
}
</style>

